import type { ReactElement } from 'react'
import { Avatar } from '@mui/material'

export interface UserAvatarProps {
  initials: string
  size: 32 | 36
}

export default function UserAvatar({ initials, size }: UserAvatarProps): ReactElement {
  return (
    <Avatar
      aria-hidden
      sx={{
        width: size,
        height: size,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        fontSize: size === 32 ? 12 : 13,
        fontWeight: 700
      }}
    >
      {initials}
    </Avatar>
  )
}
